import React, { useEffect, useRef } from "react";

const ModalTrigger = ({
  label,
  Component,
  componentProps = {},
  isOpen,
  onOpen,
  onClose,
  isAnyModalOpen,
}) => {
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (isOpen) {
      // Save current scroll position
      scrollYRef.current = window.scrollY;

      // Lock scroll by fixing the body in place
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollYRef.current}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";
    } else {
      // Unlock scroll
      const savedScrollY = scrollYRef.current;

      // Reset body styles
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";

      // Restore scroll position in next tick
      requestAnimationFrame(() => {
        window.scrollTo(0, savedScrollY);
      });
    }

    // On cleanup
    return () => {
      const savedScrollY = scrollYRef.current;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.width = "";

      requestAnimationFrame(() => {
        window.scrollTo(0, savedScrollY);
      });
    };
  }, [isOpen]);

  if (!isOpen) {
    return (
      <div className="relative z-10 flex items-center justify-center mt-4">
        {!isAnyModalOpen && (
          <button
            onClick={onOpen}
            className="text-blue-600 focus:outline-none z-20"
          >
            {label}
          </button>
        )}
      </div>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[9998] bg-black bg-opacity-50"
        aria-hidden="true"
      ></div>

      {/* Modal fixed in center */}
      <div
        className="fixed inset-0 z-[9999] flex justify-center items-center px-4 py-10"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div className="relative bg-white w-full max-w-3xl max-h-[90vh] rounded-lg shadow-xl flex flex-col overflow-hidden">
          {/* Header */}
          <div className="shrink-0 sticky top-0 z-10 bg-white px-4 sm:px-4 border-b border-gray-200 flex justify-end">
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-black text-2xl focus:outline-none"
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>

          {/* Scrollable content */}
          <div className="overflow-y-auto px-4 sm:px-6 py-4 sm:py-6 break-words whitespace-pre-wrap text-sm sm:text-base leading-relaxed flex-1">
            <Component {...componentProps} />
          </div>

          {/* Footer */}
          <div className="shrink-0 sticky bottom-0 bg-white px-4 py-2 border-t border-gray-200 flex justify-center">
            <button
              onClick={onClose}
              className="text-blue-600 underline hover:text-blue-800 focus:outline-none"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalTrigger;
